import { useEffect } from 'react';
import { useThemeStore } from '../store';
import { Moon, Sun } from 'lucide-react';
import { Button } from './ui/button';

export const ThemeProvider = ({ children }) => {
  const { theme } = useThemeStore();

  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove('light', 'dark');
    root.classList.add(theme);
    
    // Also set color-scheme for native elements
    root.style.colorScheme = theme;
  }, [theme]);

  // Initialize theme on first load from localStorage
  useEffect(() => {
    const stored = localStorage.getItem('mentis-theme');
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        if (parsed.state?.theme) {
          const root = window.document.documentElement;
          root.classList.remove('light', 'dark');
          root.classList.add(parsed.state.theme);
          root.style.colorScheme = parsed.state.theme;
        }
      } catch (e) {}
    }
  }, []);

  return children;
};

export const ThemeToggle = () => {
  const { theme, toggleTheme } = useThemeStore();

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      data-testid="theme-toggle"
      className="rounded-full"
      aria-label={theme === 'light' ? 'Dunkelmodus aktivieren' : 'Hellmodus aktivieren'}
    >
      {theme === 'light' ? (
        <Moon className="h-5 w-5" />
      ) : (
        <Sun className="h-5 w-5" />
      )}
    </Button>
  );
};

export default ThemeProvider;
